import { Box, Paper, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ManagerNavbar from './ManagerNavbar';
import CandidateNavbar from './CandidateNavbar';
import { useTheme } from '@emotion/react';
import BackButton from '../../../../common/BackButton';
import { variants } from '../../../../variants/variants';
import NavbarLayout from '../../../../common/NavbarLayout';
import { useDispatch } from 'react-redux';
import { toggleOutlet } from '../../../Announcement/announcementSlice';

const components = {
  mygift: <CandidateNavbar />,
  submitted: <ManagerNavbar />,
  invites: <ManagerNavbar history={false} />,
  manage: <ManagerNavbar history={false} />,
};
const GiftNavbar = () => {
  const { pathname } = useLocation();
  const value = pathname.split('/gift/')[1];
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleNavigateBack = () => {
    dispatch(toggleOutlet(false))
    navigate("/home/announcement/gatewaybox")
  }

  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Box sx={{ display: 'flex', alignItems: 'center', width: 1 }}>{value ? components[value] : <ManagerNavbar />}</Box>
    </NavbarLayout>
  );
};

export default GiftNavbar;
